// Cartão de preferência com interruptor (role="switch"): título, texto e, se houver, um aviso. `disabled` usa aria-disabled (continua
// focável e leitor de tela lê o motivo) e o clique não faz nada; quem chama decide quando desabilitar (ex.: Modo Desenvolvedor sem pool).
import '../styles/pref-switch.css';

export function PrefSwitch({ id, title, text, note, checked, disabled = false, busy = false, onChange }: {
  id: string; title: string; text: string; note?: string; checked: boolean; disabled?: boolean; busy?: boolean; onChange: (on: boolean) => void;
}) {
  return (
    <div className={`pref${disabled ? ' off' : ''}`}>
      <div className="pref-body">
        <h3 id={`${id}-t`}>{title}</h3>
        <p id={`${id}-d`}>{text}</p>
        {note && <p className="pref-note" id={`${id}-n`}>{note}</p>}
      </div>
      <button
        type="button" role="switch" id={id} className="switch" aria-checked={checked} aria-disabled={disabled || undefined} aria-busy={busy || undefined}
        aria-labelledby={`${id}-t`} aria-describedby={`${id}-d${note ? ` ${id}-n` : ''}`}
        onClick={() => { if (!disabled && !busy) onChange(!checked); }}
      ><i /></button>
    </div>
  );
}
